import React from "react";
import { ActivityFormRequestEditContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { userService } from "apiServices";
import { ROUTE_PATH } from "utils/constants/routePath";
import { HeaderBackHomeWidget, OnlineFormRequestEditItemWidget } from "widgets";
import { withTranslation } from "react-i18next";
import { Displays, Navigations } from "components";

class ActivityFormRequestEditContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { router } = this.props;
    let res = await userService.GET_MY_ACTIVITY_FORM_DETAIL(
      router.params?.question_id,
    );
    if (res && res.status === 200) {
      this.setState({
        data: res.data,
        isLoading: false,
      });
    }
  };

  render() {
    const { router, t } = this.props;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Activities", { ns: "common" }),
        path: ROUTE_PATH.ACTIVITIES,
      },
    ];
    const { isBgLoading, isLoading, data } = this.state;
    return (
      <ActivityFormRequestEditContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="header_back_home_layout">
          <HeaderBackHomeWidget />
        </div>
        {isLoading ? (
          <Displays.Loading />
        ) : (
          <div className="body_layout">
            {data &&
              data.question_list.map((e, i) => (
                <div key={i} className="page_block">
                  {/* <div className="page_label">
                    หน้า {e.page} {e.title}
                  </div> */}
                  <div className="question_list">
                    {e.questions &&
                      e.questions.map((f, j) => (
                        <div key={j} className="question_item">
                          <OnlineFormRequestEditItemWidget
                            activity_form_history_id={
                              router.params?.question_id
                            }
                            page={e.page}
                            {...f}
                            onRequestSuccess={this.fetchData}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              ))}
          </div>
        )}
      </ActivityFormRequestEditContainerStyled>
    );
  }
}

export default withTranslation(["common"])(withRouter(ActivityFormRequestEditContainer));
